<template>
  <div
    class="collapse-field"
    v-bind:class="{ shown }"
  >
    <button
      class="collapse-field__caption"
      title="Переключить видимость поля"
      type="button"
      v-on:click="toggle"
    >{{ caption }}</button>
    <div class="collapse-field__content">
      <slot />
    </div>
  </div>
</template>
<script>
/**
 * @description Сворачивание поля ввода.
 * @type {Vue}
 */
export default {
  data() {
    return {
      shown: this.value,
    };
  },
  methods: {
    /**
     * @description Переключить сворачивание.
     * @returns {void}
     */
    toggle() {
      const updatedValue = !this.shown;
      this.shown = updatedValue;
      this.$emit('input', updatedValue);
    },
  },
  name: 'CollapseField',
  props: {
    /**
     * @description Заголовок.
     * @type {string}
     */
    caption: {
      required: true,
      type: String,
    },
    /**
     * @description Открыто.
     * @type {boolean}
     */
    value: {
      default: () => true,
      required: false,
      type: Boolean,
    },
  },
};
</script>
<style scoped>
.collapse-field {
  pointer-events: auto;
}
.collapse-field .collapse-field__caption {
  color: var(--action-color);
  font-size: .825rem;
}
.collapse-field .collapse-field__caption:before {
  content: '+';
  display: inline-block;
  font-size: 18px;
  margin-right: .5rem;
  width: 1rem;
}
.collapse-field.shown .collapse-field__caption:before {
  content: '-';
}
.collapse-field .collapse-field__content {
  display: none;
}
.collapse-field.shown .collapse-field__content {
  display: contents;
}
@media print {
  .collapse-field .collapse-field__caption {
    display: none;
  }
  .collapse-field .collapse-field__content {
    display: contents;
  }
}
</style>
